import React, { useEffect, useState } from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { setGeoLocationState } from "../../../../redux/actions/geoLocationActions";
import { I18nContext } from "../../../../i18n/index";
import { Link } from "@reach/router";

export default function NoItems({ component }) {
  const dispatch = useDispatch();
  const { translate } = React.useContext(I18nContext);

  const [closestStore, setClosestStore] = useState(null);
  const [
    totalProductCountOfSellersFacet,
    setTotalProductCountOfSellersFacet
  ] = useState(null);

  const userInfoState = useSelector(
    state => state.loginReducer.userInfo,
    shallowEqual
  );

  const geoLocationState = useSelector(
    state => state.geoLocationReducer.geoLocation,
    shallowEqual
  );

  const numberOfItemState = useSelector(
    state => state.categoryReducer.numberOfItems,
    shallowEqual
  );

  const loadingState = useSelector(
    state => state.categoryReducer.loading,
    shallowEqual
  );

  const distanceState = useSelector(
    state => state.categoryReducer.distance,
    shallowEqual
  );

  const numberOfStoreItemsState = useSelector(
    state => state.storeReducer.numberOfItems,
    shallowEqual
  );

  console.info("NumberofItems Component, closest store", closestStore);

  const handleLocationBtnClicked = location => {
    dispatch(setGeoLocationState(location));
  };

  const handleOpenLocationBox = () => {
    const button = document.getElementById("locationChangeBtn");
    button.click();
  };

  const renderDataCountContent = () => {
    const renderNumberOfItems = () => {
      if (component && component == "stores") {
        return numberOfStoreItemsState;
      } else {
        return numberOfItemState;
      }
    };

    const renderNumberOfProductsFoundText = () => {
      if (component && component == "stores") {
        return `${
          numberOfStoreItemsState > 1
            ? ` ${translate("js.category.productsfound")}`
            : ` ${translate("js.category.productfound")}`
        }`;
      } else {
        return `${
          numberOfItemState > 1
            ? ` ${translate("js.category.productsfound")}`
            : ` ${translate("js.category.productfound")}`
        }`;
      }
    };

    return <div className="data-count-content"></div>;
  };

  return (
    <React.Fragment>
      {!loadingState ? (
        <div className="dataCount">{renderDataCountContent()}</div>
      ) : null}
    </React.Fragment>
  );
}
